import React, { useState } from 'react';
import TBodyRow from './TBodyRow';

interface IProps {
  moduleData: any;
  isView: boolean;
  handelDeleteRows: any;
  department: string;
}

const TBody = ({
  moduleData,
  isView,
  handelDeleteRows,
  department,
}: IProps) => {
  // const [render, setRender] = useState(false);
  return (
    <>
      <tbody>
        {moduleData &&
          moduleData?.list?.map((oneListObj: any, index: number) => (
            <React.Fragment key={index + 1 + 'process'}>
              <TBodyRow
                {...{
                  moduleData,
                  oneListObj,
                  index,
                  isView,
                  handelDeleteRows,
                  department,
                }}
              />
            </React.Fragment>
          ))}
      </tbody>
    </>
  );
};

export default TBody;
